import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MdbModalModule, MdbModalService, MdbDatepickerModule, MdbRadioModule, MdbAutocompleteModule } from 'src/lib/mdb5-adapted/public-api';
import { NgxPaginationModule } from 'ngx-pagination';

import { LmsPaginateComponent } from '@lmsShared';

import { BasicEmployersSearchComponent } from './basic-employer-form/basic-employer-form.component';
import { UpdateEmployerComponent } from './update-employer/update-employer.component';
import { EmployerService } from './services/employer.service';
import { CsvParserService } from './services/csv-parser.service';
import { UpdateEmployerService } from './services/update-employer.service';
import { EmployerListComponent } from './name-correction/employer-list.component';

// export const routes:Routes = [
//   { path: '',pathMatch:'prefix', redirectTo:'updateEmployers' },
//   //{ path: 'add-branch-employer', component: AddContactComponent },
//   { path: 'updateEmployers', component: UpdateEmployerComponent }
//   //{ path: 'edit-branch-employer', component: EditContactComponent },
//   //{ path: 'view-branch-employers', component: ViewContactsComponent },
//   //{ path: 'view-branch-employer', component: ViewContactComponent }
// ];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    LmsPaginateComponent,
    MdbRadioModule,
    MdbDatepickerModule,
    MdbAutocompleteModule,
    MdbModalModule,
    BasicEmployersSearchComponent,
    UpdateEmployerComponent,
    EmployerListComponent
  ],
  providers: [MdbModalService, EmployerService, CsvParserService, UpdateEmployerService],
  // exports: [
  //     UpdateEmployerComponent
  // ]
})
export class BranchEmployersModule {}
